import { render, staticRenderFns } from "./EditorInput.vue?vue&type=template&id=3b174241&scoped=true"
import script from "./EditorInput.vue?vue&type=script&lang=js"
export * from "./EditorInput.vue?vue&type=script&lang=js"
import style0 from "./EditorInput.vue?vue&type=style&index=0&id=3b174241&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b174241",
  null
  
)

export default component.exports